import { Component } from "react"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import ApiHandler from "src/api/ApiHandler"
import ErrorHandler from "src/components/errors/ErrorHandler"
import StateConstants from "src/states/StateContstants"
import Loader from "src/components/general/Loading"
import Helmet from "react-helmet"
import AreaSearchForm from "src/components/search/AreaSearchForm"
import "src/components/search/Search.css"

interface AreaSearchPageProps {
    stateHandler: EventAdaptingStateHandler
    apiHandler: ApiHandler
    errorHandler: ErrorHandler
    loader: Loader
}

interface AreaSearchPageState {
    isLoading: boolean
}

export default class AreaSearchPage extends Component<AreaSearchPageProps, AreaSearchPageState> {
    stateHandler: EventAdaptingStateHandler
    apiHandler: ApiHandler
    errorHandler: ErrorHandler
    loader: Loader
    state: AreaSearchPageState

    constructor(props: AreaSearchPageProps) {
        super(props)
        this.stateHandler = props.stateHandler
        this.apiHandler = props.apiHandler
        this.errorHandler = props.errorHandler
        this.loader = props.loader
        this.state = { isLoading: false }
        this.stateHandler.addListener(StateConstants.IS_LOADING, (state: boolean) => {
            this.setState((prevState) => ({ ...prevState, isLoading: state }))
        })
        this.stateHandler.addListener(StateConstants.ERROR, () => {
            this.setState({})
        })
    }

    render() {
        const { isLoading } = this.state

        if (isLoading) {
            return this.loader.render("Searching for area")
        }

        return (
            <div>
                <Helmet>
                    <title>Search areas – HomeIndex</title>
                    <meta name="description" content="Search neighbourhoods and areas. View area statistics, median prices and recent sales." />
                </Helmet>
                {this.errorHandler.render(this.stateHandler.get("error"), {
                    onDismiss: () => this.stateHandler.set(StateConstants.ERROR, null)
                })}
                <div className="valuations-home-page area-search-page">
                    <img
                        src="/areas.webp"
                        alt=""
                        className="valuations-home-page-bg"
                        fetchPriority="high"
                        decoding="async"
                    />
                    <div className="valuation-description">
                        <p>Search areas</p>
                    </div>
                    <AreaSearchForm stateHandler={this.stateHandler} apiHandler={this.apiHandler} border={false} />
                    <div className="explanation-text">
                        <p>View area insights and recent sales.</p>
                        <p>Find out more about the housing market in your area.</p>
                    </div>
                </div>
            </div>
        )
    }
}
